
import { defineComponent } from 'vue';
import VerifyAccountNotice from '@/components/sections/verify-account/VerifyAccountNotice.vue';
import { mapActions, mapGetters } from 'vuex';
import { Actions, Getters } from '@/store/enums/VerifyAccountEnums';
import toasts from '@/utils/toasts';

export default defineComponent({
  name: 'verify-account-notice',
  components: {
    VerifyAccountNotice,
  },
  data: () => ({
    sending: false,
  }),
  computed: {
    ...mapGetters({
      errors: Getters.GET_ACTION_ERROR,
    }),
  },
  methods: {
    ...mapActions({
      requestNewToken: Actions.REQUEST_NEW_TOKEN,
    }),
    handleClick() {
      if (this.sending) return;

      this.sending = true;

      this.requestNewToken()
        .then(() => {
          this.sending = false;
          toasts.success(
            'New verification link sent. Please check your email.'
          );
        })
        .catch(() => {
          this.sending = false;
          const { errors, messages } = this.errors;
          toasts.error(errors, messages);
        });
    },
  },
});
